import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { resolveFilters } from "@api/utilities/api.utility";

export const useGetAllPartnerUserService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const resolvedFilters = resolveFilters(filters);
  const allPartnerUsersService = useQuery({
    queryKey: [
      ...CACHE_KEYS.PARTNER_USERS,
      page,
      debouncedQuery,
      per_page,
      JSON.stringify(resolvedFilters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.PARTNER_USERS,
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
          include: "roles,partner",
          ...resolvedFilters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allPartnerUsersService },
    states: { searchQuery, setSearchQuery },
  };
};
